import React from 'react';

export default function WhatsAppConsentControls({ preference }) {
  const statusText = preference?.status === 'opted_out'
    ? 'Customer opted out'
    : preference?.status === 'opted_in' ? 'Customer opted in' : 'No START or STOP received';
  const detectedAt = preference?.status_at && !Number.isNaN(Date.parse(preference.status_at))
    ? new Date(preference.status_at).toLocaleString() : '';

  return <section className="space-y-2 border-t pt-4" aria-label="WhatsApp messaging permission">
    <div>
      <h3 className="text-sm font-semibold">Messaging permission</h3>
      <p className={`text-xs ${preference?.status === 'opted_out' ? 'text-red-800' : 'text-gray-600'}`}>{statusText}</p>
    </div>
    <div className="rounded-lg bg-gray-50 p-2 text-xs text-gray-700">
      <p>LeadMarka updates this automatically when the customer sends <strong>START</strong> or <strong>STOP</strong>.</p>
      {detectedAt && <p className="mt-1">Last updated <time dateTime={preference.status_at}>{detectedAt}</time></p>}
    </div>
  </section>;
}
